import { Box, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <Box mt="20px">
      <Typography sx={{textAlign: "center", pb: "20px"}} variant="h5">Made by <a href="https://danthecm.netlify.app">DanTheCM</a></Typography>
    </Box>
  )
}

export default Footer